const INITIAL_STATE = {};

export const longTransactions = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'UPDATE_LONG_TRANSACTION_LOADING_STATUS':
      // eslint-disable-next-line
      let longTransactions = { ...state };

      longTransactions[action.ticketId] = {
        isPending: action.value,
      };

      return { ...longTransactions };
    default:
      return state;
  }
};

export default longTransactions;
